import { IconButton, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/pro-regular-svg-icons';
import React, { useCallback, useState } from 'react';

export const CopyToClipboard = ({ value, tooltip = 'Copy' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback((e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [value]);

  if (!value) return null;

  return (
    <Tooltip title={copied ? 'Copied!' : tooltip}>
      <IconButton onClick={handleCopy} size="small" color={copied ? 'success' : 'default'} aria-label={copied ? 'Copied' : tooltip}>
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} style={{ width: 14, height: 14 }} />
      </IconButton>
    </Tooltip>
  );
};
